import { Answers } from './components/Answers';
import QuestionName from './components/QuestionName';
import { Tags } from './components/Tags';
import { useConstructor } from './hooks/ConstructorHook';
import style from'./task-creator.module.css'
import AddFile from "./components/AddFile";
import Type from "./components/Type";
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import {Navigate, useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import API from "../../API";
import Context from "../../context";
function Index() {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;
    const { mainState,setIsLoading } = useContext(Context)

    const api = new API()
    const {changeName, changeType, sendQuestion, changeAnswers, changeTags, deleteAnswers,editQuestion,setAnswers,
        changeTypeForEighth, type,setType,setAllTags,changeTextAnswers,changePercent,changeParameterType2} = useConstructor()
    const { id } = useParams();
    const [data,setData]=useState(null)
    useEffect(()=>{
        if(id){
            setIsLoading(true)
            api.getOneQuestion(id).then(dataQuestion=>{
                let question = JSON.parse(JSON.stringify(dataQuestion))
                setType(dataQuestion.type.toString())
                changeName(dataQuestion.description)
                setAnswers(dataQuestion.answers)
                const tagsArray =Object.values(dataQuestion.tags)
                let tag = []
                tagsArray.forEach((item) => {
                    tag = [
                        ...tag,
                        ...item,
                    ]
                })
                changeTags(tag)
                question.tags = tag
                setData(question)
                setIsLoading(false)
            })
        }
    },[id])
    // if(isLoading){
    //     return <Loader/>
    // }
    return (
        mainState.isLoggedIn && (mainState.type === "Editor" ||mainState.type === "Admin") ?
        <div className={style.task_main}>
            <div className={style.task_main_content}>
                <div className={style.task_main_content_block}>
                    <div>

                        <div className={style.task_header_item}>
                            <h1>{language.createTaskTitle}</h1>
                        </div>
                        <div className={`${style.task_dark} ${style.task_header_type}`}>
                            <Type defaultType={data ? data.type : ''} changeType={changeType}/>
                        </div>
                        {type && <QuestionName defaultName={data ? data.description:''} id={type} change={changeName}/>}
                        {type && <Answers defaultValue={data? data.answers:[]}
                                          deleteAnswers={deleteAnswers}
                                          typeId={type}
                                          changeAnswers={changeAnswers}
                                          changeTypeForEighth={changeTypeForEighth}
                                          changeTextAnswers={changeTextAnswers}
                                          changePercent={changePercent}
                                          changeParameterType2={changeParameterType2}
                        />}
                        {type && <Tags changeTags={changeTags} defaultValue={data?data.tags:null} setAllTags={setAllTags}/>}
                        <div className={style.task_answers_buttons_block}>
                            {type && <button className={style.task_answers_btn}
                                             onClick={() => id ? editQuestion(id) : sendQuestion()}>{language.createTaskMakeQuestion}</button>}

                        </div>
                    </div>
                    <div>
                        {type && <AddFile/>}
                    </div>
                </div>
            </div>
        </div>:<Navigate to="/*" />
    );
}

export default Index;
